// This file is auto-generated by the installer.
import xetuxConfig from 'plugins/xetux-config';
import toastConfig from 'plugins/toast-config';
import xetuxConfigAnswer from 'plugins/xetux-config/types/AnswerType';
import toastConfigAnswer from 'plugins/toast-config/types/AnswerType';

export type PluginsPreSurveyAnswers = xetuxConfigAnswer | toastConfigAnswer;

const configDictionary = {
"xetux-config" : xetuxConfig,
"toast-config" : toastConfig 
}

export default configDictionary;
    
